<template>
    <b-container>
        <b-row align-h="center">
            <b-col sm="6" md="4" lg="6">
                <b-card
                    no-body
                    header-bg-variant="primary"
                    class="text-secondary-light header-text text-right"
                >
                    <img src="./../assets/colab-logo.svg" height="100" width="100" alt="coLab" class="logo" slot="header">
                    <h3 slot="header" style="font-weight: normal">enaio® coLab</h3>

                    <b-card-body class="text-left">
                        <table class="table table-condensed" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td class="text-dark">{{ $t('general.about.componentVersion') }}:</td>
                                    <td>{{ componentVersion }}</td>
                                </tr>
                                <tr>
                                    <td class="text-dark">{{ $t('general.about.productVersion') }}:</td>
                                    <td>{{ productVersion }}</td>
                                </tr>
                                <tr>
                                    <td class="text-dark">{{ $t('general.about.manufacturer') }}:</td>
                                    <td>{{ $t('general.about.manufacturerText') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <a :href="documentationLink" target="_blank" class="pull-right" style="font-size: small">{{ $t('general.about.userDocumentation') }} ➜</a>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import systemApi from './../api/system.js';

export default {
    name: 'about',

    data() {
        return {
            componentVersion: undefined,
            productVersion: undefined,
            documentationLink: undefined
        }
    },

    created() {
        systemApi.getAboutInfo().then(result => {
            if (result && result.data) {
                this.componentVersion = result.data.componentVersion;
                this.productVersion = result.data.productVersion;
                this.documentationLink = result.data.documentationLink;
            }
        });
    }
}
</script>
